import React from 'react';
import ReactDOM from 'react-dom';

type Constructor<T> = { new (...args: any[]): T };

export function findDOMNodeOrThrow<T>(
  node: React.ReactInstance | null | undefined,
  type: Constructor<T>
): T {
  const domNode = ReactDOM.findDOMNode(node);
  if (isOfType(domNode, type)) {
    return domNode;
  } else {
    throw new Error(`ReactDOM.findDOMNode returned null or a non ${type.toString()}`);
  }
}

function isOfType<T>(object: any, type: Constructor<T>): object is T {
  return object instanceof type;
}
